<template>
  <div>
    <h1>欢迎登录</h1>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
  h1{
    color:#303003;
  }
  p{
    color:#303030;
    line-height: 2.2;
  }
</style>
